import { MAX_PREPAYMENTS } from '@/js/common/Constants/globalParams';

/**
 * Сервис для получения размера возможной предоплаты (10%, 50%).
 * @param tourData - набор данных необходимых для получения предоплаты.
 * Правило следующее: самым приоритетным для показа являтся более низкая предоплата.
 * @returns {Object} - возможная первоначальная оплата (10%, 50%) с условиями.
 */
export default (data) => _.min(data.firstPaymentDefinitions?.slice(0, MAX_PREPAYMENTS) || [], (firstPaymentDefinition) => firstPaymentDefinition?.firstPaymentPart || Infinity);